export function compressFile(file, level = 10) {
    return new Promise((resolve, reject) => {
        const worker = new Worker(new URL("./compress-worker.js", import.meta.url));

        worker.onmessage = (event) => {
            resolve(event.data);
            worker.terminate();
        };

        worker.onerror = (error) => {
            reject(error);
            worker.terminate();
        };

        worker.postMessage({ file, level });
    });
}

export function decompressFile(bytes) {
    return new Promise((resolve, reject) => {
        const worker = new Worker(new URL("./decompress-worker.js", import.meta.url));

        worker.onmessage = (event) => {
            resolve(event.data);
            worker.terminate();
        };

        worker.onerror = (error) => {
            reject(error);
            worker.terminate();
        };

        worker.postMessage({ bytes });
    });
}